import {useEffect, useRef, useState} from "react";
import {Button, Form, message, notification, Select, Table, Tabs, Typography} from "antd";
import {v4} from "uuid";
import HecRasHelper from "../Helpers/HecRasHelper";
import ProjectInfo from "./ProjectInfo";
import {PlanProfiles, PlanTypes} from "./ProjectUploader";
import {DefaultProject} from "../Context/ProjectContext";
import {useHistory} from "react-router-dom";


export default function HecRasProject({project, onProjectChanged, onRemoved})
{
    const history = useHistory()
    const [tempProject, setTempProject] = useState({
        isChanged: false,
        ...DefaultProject
    })
    const [expandedKeys, setExpandedKeys] = useState([])

    useEffect(() => {
        if(project) {
            const keys = []
            project.projectFiles?.forEach(x => {
                if(x.mapProfiles.filter(x => x.target).length > 0)
                    keys.push(x.id)
            })

            setExpandedKeys(keys)
            setTempProject({
                ...project,
                isChanged: false
            })
        }
    }, [project])

    useEffect(() => {
        if(tempProject?.isChanged) {
            onProjectChanged({
                ...tempProject
            })
        }
    }, [tempProject])

    const renderFile = (file) => {
        if(file)
        {
            return (
                <div>
                    <div><b>{file.title}</b></div>
                    <div>{file.fileName}</div>
                </div>
            )
        }

        return (
            <b style={{color: '#ff0000'}}>Not Found</b>
        )
    }

    const renderOutputCol = (row) => {
        if(!row.profileData || Object.keys(row.profileData).length === 0)
            return (
                <div>
                    <b key={v4()} style={{color: '#ff0000'}}>Not Found</b>
                </div>
            )

        return (
            <div>
                {row.plan.shortIdentifier}
            </div>
        )
    }

    const onTypeChanged = (row, val) => {

        const index = tempProject.projectFiles.findIndex(x => x.id === row.id);
        if(index >= 0)
        {
            tempProject.projectFiles[index].type = val
            setTempProject({
                ...tempProject,
                isChanged: true
            })
        }
    }

    const remove = (row) => {
        const files = tempProject.projectFiles.filter(x => x.id !== row.id);
        setTempProject({
            ...tempProject,
            projectFiles: files,
            isChanged: true
        })
    }

    const renderRowExpand = (row) => {
        const onChangeProfile = (select, val) => {
            setTempProject((prev) => {
                const data = {...prev}

                data.projectFiles = data.projectFiles.map(plan => {
                    if(plan.id === row.id)
                    {
                        plan.id = v4()
                        plan.mapProfiles = plan.mapProfiles.map(map => {
                            if(map.select === select)
                            {
                                map.target = val
                                map.targetName = PlanProfiles.find(x => x.value === val)?.label || val
                            }

                            return map
                        })
                    }

                    return plan
                })

                data.projectFiles = data.projectFiles.map(plan => {
                    plan.mappedProfiles = HecRasHelper.mapProfiles(plan.profileData, plan.mapProfiles)
                    return plan
                })
                data.isChanged = true

                return data
            })
        }

        return (
            <div style={{marginLeft: 72}}>
                <table>
                    <tbody>
                    {row.mapProfiles.map(x => (
                        <tr>
                            <td style={{width:150}}>{x.select}</td>
                            <Select
                                size={'small'}
                                defaultValue={x.target}
                                placeholder={'Select Profile'}
                                allowClear={true}
                                onClear={() => {
                                    onChangeProfile(x.select, '')
                                }}
                                onChange={(val) => onChangeProfile(x.select, val)}
                                style={{width: 200, marginBottom: 4}}
                            >
                                <Select.Option value={x.select}>
                                    {x.select}
                                </Select.Option>
                                {
                                    PlanProfiles.map(y => (
                                        <Select.Option value={y.value}>
                                            {y.label}
                                        </Select.Option>
                                    ))
                                }
                            </Select>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        )
    }

    const getVersions = () => {
        const list = tempProject.projectFiles.map(x => x.plan.version).filter(x => x && x.trim());
        return [...new Set(list)].join(', ')
    }


    const getPlanId = (row) => {
        const splitted = row.plan.fileName.split('.')
        return `${row.plan.shortIdentifier}.${splitted[splitted.length-1]}`
    }


    useEffect(() => {

    }, [tempProject])

    return (
        <>
            <div style={{marginBottom: 32}}>
                <div>
                    {
                        tempProject.information?.title && (
                            <ProjectInfo
                                autoHeight={true}
                                autoHeightKey={'hecrasProject'}
                                folderName={tempProject.information?.folderName}
                                title={tempProject.information?.title}
                                descriptions={tempProject.information?.descriptions}
                                version={
                                    tempProject.projectFiles && tempProject?.projectFiles?.length > 0 && getVersions()
                                }
                            />
                        )
                    }
                    {
                        tempProject.information?.outputColumns?.length > 0 && (
                            <div
                                style={{
                                    backgroundColor: '#FBE5D6',
                                    padding: 4,
                                    border: '1px solid black'
                                }}
                            >
                                The following variables are missing in the output file. These variables are essential to make the relevant checks and comparisons.
                                <div style={{color: '#ff0000'}}>
                                    {
                                        tempProject.information?.outputColumns?.join(', ')
                                    }
                                </div>
                            </div>
                        )
                    }
                    {
                        (tempProject.information?.hasOutputFile === 'false') && (
                            <div
                                style={{
                                    backgroundColor: '#FBE5D6',
                                    padding: 4,
                                    border: '1px solid black'
                                }}
                            >
                                The output text file is missing in the project folder! RAS Review will still check and compare geometry and flow that does not require the calculated water surface elevation. For full functionality create and include the output text file as directed in
                                <a onClick={() => {history.push('/app/help?type=output')}}>{' '}How to menu.</a>
                            </div>
                        )
                    }
                    <br/>
                </div>
                {
                    tempProject.information?.title && (
                        <Button
                            style={{marginTop: 8}}
                            type={'primary'}
                            size={'small'}
                            onClick={() => {
                                setTempProject({
                                    ...DefaultProject
                                })
                                onRemoved && onRemoved()
                                setExpandedKeys([])
                            }}
                        >
                            Remove
                        </Button>
                    )
                }
                <div style={{marginBottom: 12}} />
                {
                    tempProject.information?.title && (
                        <Table
                            size={'small'}
                            dataSource={tempProject.projectFiles}
                            pagination={false}
                            rowKey={'id'}
                            id={'id'}
                            expandable={{
                                expandedRowRender: renderRowExpand,
                                rowExpandable: () => true,
                                expandedRowKeys: expandedKeys,
                                onExpand: (expanded, record) => {
                                    const keys = expandedKeys.filter(x => x !== record.id)
                                    if(keys.length !== expandedKeys.length)
                                        setExpandedKeys(keys)
                                    else
                                        setExpandedKeys([
                                            ...expandedKeys, record.id
                                        ])

                                    return true
                                }
                            }}
                            columns={[
                                {dataIndex: '#', title: '#', key: '#', render: (text, row) => (<a onClick={() => remove(row)} style={{color: '#ff0000'}}>X</a>)},
                                {dataIndex: 'plan', title: 'Plan', key: 'plan', render: (text, row) => renderFile(row.plan)},
                                {dataIndex: 'flow', title: 'Flow', key: 'flow', render: (text, row) => renderFile(row.flow)},
                                {dataIndex: 'geometry', title: 'Geometry', key: 'geometry', render: (text, row) => renderFile(row.geometry)},
                                {dataIndex: 'output', title: 'Output', key: 'output', render: (text, row) => renderOutputCol(row)},
                                {dataIndex: 'type', title: 'Type', key: 'type', render: (text, row) => {
                                        getPlanId(row)
                                        return (
                                            <Select
                                                size={'small'}
                                                defaultValue={row.type}
                                                style={{minWidth: 120}}
                                                onSelect={(val) => {onTypeChanged(row, val)}}
                                                placeholder={'Select Type'}
                                                allowClear={true}
                                                onClear={() => {
                                                    onTypeChanged(row, '')
                                                }}
                                            >
                                                <Select.Option value={getPlanId(row)} key={getPlanId(row)}>{getPlanId(row)}</Select.Option>
                                                {
                                                    PlanTypes.map(x => (<Select.Option value={x.label} key={x.label}>{x.label}</Select.Option>))
                                                }
                                            </Select>
                                        )
                                    }},
                            ]}
                        />
                    )
                }
            </div>
        </>
    )
}
